export const ACCESSIBILITY_MODAL = {
    HIDE_FOR_SCREEN_READERS_LABEL: {
      key: 'HIDE_FOR_SCREEN_READERS_LABEL',
      value: 'Hide for Screen readers'
    },
    ACCESSIBILITY_TOOLTIP: {
      key: 'ACCESSIBILITY_TOOLTIP',
      value: 'Accessibility'
    },
    SUMMARY_SCREEN_READER_LABEL: {
      key: 'SUMMARY_SCREEN_READER_LABEL',
      value: 'Provide a summary for screen readers:'
    },
    LINK_ENTER_LABEL: {
      key: 'LINK_ENTER_LABEL',
      value: 'Enter Redirection Link'
    },
    LINK_VISIT_LABEL: {
      key: 'LINK_VISIT_LABEL',
      value: 'Visit the Link'
    },
    LINK_SAVE: {
      key: 'LINK_SAVE',
      value: 'Save'
    },
    LINK_EDIT: {
      key: 'LINK_EDIT',
      value: 'Edit'
    },
    LINK_REMOVE: {
      key: 'LINK_REMOVE',
      value: 'Remove'
    },
    LINK_INVALID_URL: {
      key: 'LINK_INVALID_URL',
      value: 'Please enter a valid URL (e.g. https://example.com)'
    },
  };